import ShadeAdvancedView from './ShadeAdvancedView'

export default ShadeAdvancedView
